import { render, staticRenderFns } from "./LegacyTransactionHistory.vue?vue&type=template&id=1c71a40c&scoped=true&"
import script from "./LegacyTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./LegacyTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71a40c",
  null
  
)

export default component.exports